import { useUserStore } from '../stores/userStore';
import { usePermission } from '../composables/usePermission';
import { getAuthorizationConfig } from '../utils/authorizationConfig';

/**
 * This middleware checks whether the user is authenticated before allowing access to certain routes.
 * If the user is not authenticated and the route does not have the `publicAccess` meta property set to true,
 * the user is redirected to the `/signin` route with a `redirect` query parameter containing the intended route.
 * use definePageMeta composable to set publicAccess meta property
 */
export default defineNuxtRouteMiddleware(async (to) => {
    // Check if the route requires authentication
    if (!to.meta.publicAccess) {
        const auth = useUserStore();
        await auth.isReady();
        if (!auth.isAuthenticated) {
            return navigateTo({
                path: '/signin',
                query: { redirect: to.fullPath }
            });
        }
        const authConfig = getAuthorizationConfig(to);
        if (!authConfig) { return; }
        const { hasPermission } = usePermission();
        const { resourceType, resourceName, action, vinceApp } = authConfig;
        if (!hasPermission(resourceType, resourceName, action, vinceApp)) {
            return navigateTo('/forbidden');
        }
    }
});
